
















































import BaseComponent from '@/components/base-component.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { addDays, addMonths, addYears, setDay } from '@/helpers/dateUtils';
import * as service from '@/services/crm-dashboard';
import moment from 'moment';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    UiFilterContainer,
    UiDatePickerRange
  }
})
export default class CrmDashboardFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  filter: any = { datas: null };
  geoareas = [];
  visitors = [];

  periodo = 'u7';
  itensPeriodo = [
    { id: 'h', label: 'Hoje' },
    { id: 'o', label: 'Ontem' },
    { id: 'u3', label: '3 dias' },
    { id: 'u7', label: '7 dias' },
    { id: 'u15', label: '15 dias' },
    { id: 'm', label: 'Mês atual' },
    { id: 'ma', label: 'Mês Anterior' },
    { id: 'u1m', label: '1 mês' },
    { id: 'u2m', label: '2 meses' },
    { id: 'u3m', label: '3 meses' },
    { id: 'u6m', label: '6 meses' },
    { id: 'ua', label: '1 ano' }
  ];

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.emitFilter();
  }

  mounted() {
    this.loadCombos();
    this.emitFilter();
  }

  emitFilter() {
    this.$emit('filter', this.filter);
  }

  loadCombos() {
    service.listCrmDashboardGeoareas().subscribe((res) => {
      this.geoareas = res;
    });
    service.listCrmDashboardVisitors().subscribe((res) => {
      this.visitors = res;
    });
  }

  @Watch('periodo', { immediate: true })
  public onPeriodoChange(n) {
    let d1 = null;
    let d2 = null;
    if (n == 'h') {
      d1 = new Date();
      d2 = new Date();
    } else if (n == 'o') {
      d1 = addDays(new Date(), -1);
      d2 = addDays(new Date(), -1);
    } else if (n == 'u3') {
      d1 = addDays(new Date(), -3);
      d2 = new Date();
    } else if (n == 'u7') {
      d1 = addDays(new Date(), -7);
      d2 = new Date();
    } else if (n == 'u15') {
      d1 = addDays(new Date(), -15);
      d2 = new Date();
    } else if (n == 'u1m') {
      d1 = addMonths(new Date(), -1);
      d2 = new Date();
    } else if (n == 'm') {
      d1 = setDay(new Date(), 1);
      d2 = new Date();
    } else if (n == 'ma') {
      d1 = setDay(addMonths(new Date(), -1), 1);
      d2 = addDays(setDay(new Date(), 1), -1);
    } else if (n == 'u2m') {
      d1 = addMonths(new Date(), -2);
      d2 = new Date();
    } else if (n == 'u3m') {
      d1 = addMonths(new Date(), -3);
      d2 = new Date();
    } else if (n == 'u6m') {
      d1 = addMonths(new Date(), -6);
      d2 = new Date();
    } else if (n == 'ua') {
      d1 = addYears(new Date(), -1);
      d2 = new Date();
    }
    this.filter.datas = [moment(d1).format('YYYY-MM-DD'), moment(d2).format('YYYY-MM-DD')];
  }
}
